<template>
    <div>
        <div class="grid-full grid">
            <template v-for="(personne, index) in personnes" :key="index">
                <cogi-label cssClass="gridspan8" label="Prenom" />
                <cogi-label cssClass="gridspan8" label="Nom" />
                <cogi-regex cssClass="gridspan8" :disabled="true" v-model="personne.prenom" />
                <cogi-regex cssClass="gridspan8" :disabled="true" v-model="personne.nom" />
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
    import CogiLabel from './CogiLabel.vue'
    import CogiRegex from './CogiRegex.vue'
    import type { del } from '@/clients/delclient'

    interface IPropsListePersonnes {
        personnes: del.PersonneModel[]
    }

    defineProps<IPropsListePersonnes>()
</script>
